<template>
  <div :class="$style['pt-adult-out-stock']" @click="catchFocus">
    <pt-page-title title="样本出库"></pt-page-title>
    <el-tabs v-model="activeName" type="card">
			<el-tab-pane label="扫码方式" name="扫码方式">
				<scan ref="scan"></scan>
			</el-tab-pane>
      <el-tab-pane label="上传文件" name="上传文件">
        <upload ref="upload"></upload>
      </el-tab-pane>
		</el-tabs>
    <div class="button-div">
        <el-button type="primary" @click="submit">提交</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
// 组件class前缀
import scan from './comps/scan'
import upload from './comps/upload'
const prefixCls = 'pt-adult-out-stock'
export default {
  name: 'pt-adult-out-stock',
  components: { scan, upload },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      activeName: '扫码方式'
    }
  },
  methods: {
    catchFocus (e) {
      document.querySelector('.scan-input').focus()
    },
    submit () {
      if (this.activeName === '扫码方式') {
        this.$refs.scan.scanSubmit()
      } else {
        this.$refs.upload.uploadSubmit()
      }
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-adult-out-stock{

}
</style>
